import React from 'react';
import RadioComponent from './RadioComponent';
import Label from './Label';
import Tooltip from './Tooltip';

const Panelize = (props) => {
  const { name, groupName, errorMessage, onChangeParameter } = props;
  const onChange = e => onChangeParameter(name, e.target.value);
  return (
    <div className="form-group">
      <Label label={props.label} required={props.required}>
        <Tooltip id={`tooltip-${props.name}`} title={props.tooltip} />
      </Label>
      <div className="radio-group">
        <RadioComponent
          {...props}
          checked={props.parameters[name] === props.noValue}
          className={props.className}
          inputClassName={props.inputClassName}
          inputId={`panelize-no-${groupName}`}
          inline
          label={props.noLabel}
          name={name}
          onChange={onChange}
          groupName={props.groupName}
          value={props.noValue} />
        <RadioComponent
          {...props}
          checked={props.parameters[name] === props.yesValue}
          className={props.className}
          inputClassName={props.inputClassName}
          inputId={`panelize-yes-${groupName}`}
          inline
          label={props.yesLabel}
          name={name}
          onChange={onChange}
          groupName={props.groupName}
          value={props.yesValue} />
        <div className="error-place" />
      </div>
      {errorMessage}
    </div>
  );
};

Panelize.defaultProps = {
  options: [],
  label: 'Is circuit board panelized?',
  name: 'panelize',
  yesLabel: 'Yes',
  yesValue: '1',
  noLabel: 'No',
  noValue: '0',
};

export default Panelize;
